import { ApplicationRef, NgModule } from '@angular/core';
// import { CoreModule } from './core/core.module';
import { AppComponent } from './app.component';
import { LoginalertComponent } from './loginalert/loginalert.component';
import { CoreModule } from './core/core.module';
import { LoginalertService } from './core/services/loginalert.service';
import { CommonModule } from '@angular/common';
import { AssetsContextPipe } from './pipes/assets.pipes';



@NgModule({
  declarations: [
    AppComponent,
    LoginalertComponent,
    AssetsContextPipe
  ],
  imports: [
     CoreModule,
     CommonModule
  ],
  providers: [
     LoginalertService,
  ],
  entryComponents: [AppComponent]
})
export class AppModule {
  private appRootSelector = 'alert-widget-root';

      ngDoBootstrap(appRef: ApplicationRef) {
    const rootElements = document.querySelectorAll(this.appRootSelector);
    // cast due to https://github.com/Microsoft/TypeScript/issues/4947
    for (const element of rootElements as any as HTMLElement[]) {
      // Make sure we aren't loading on a HTMLElement that is already bootstrapped
      if (!element.attributes['genericWidgetLoaded']) {
        element.setAttribute('genericWidgetLoaded', 'true');

        // Bootstrap!
        appRef.bootstrap(AppComponent, element);
        break;
      } else {
        console.error('NOT Bootstrapping', element, (<any>element).widget);
      }
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/app.module.ts